import { render, staticRenderFns } from "./DiagnosticRecommendation.vue?vue&type=template&id=704edaf9&scoped=true"
import script from "./DiagnosticRecommendation.vue?vue&type=script&lang=js"
export * from "./DiagnosticRecommendation.vue?vue&type=script&lang=js"
import style0 from "./DiagnosticRecommendation.vue?vue&type=style&index=0&id=704edaf9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704edaf9",
  null
  
)

export default component.exports